<template>
  <div
    class="flex justify-between items-center p-4 cursor-pointer"
    @click="show = true"
  >
    <div class="flex items-center gap-2 flex-wrap">
      <i
        :class="[
          'iconfont icon-collection',
          selected.length > 0 && 'text-primary',
        ]"
      />
      <span v-if="selected.length === 0">
        {{ $t("collection.join") }}
      </span>
      <span v-else class="text-primary">
        {{ selected.map((v) => store.collectionMap[v]?.title).join(", ") }}
      </span>
    </div>
    <div>
      <i class="iconfont icon-i-right"></i>
    </div>
  </div>

  <VanPopup
    v-model:show="show"
    class="h-[80%] overflow-hidden grid grid-rows-[auto_1fr]"
    position="bottom"
    round
    teleport="body"
  >
    <ThreadsNav :go-back="() => (show = false)" :show-center="false" show-back>
      <!-- <template #center>
        {{ $t(`collection.select`) }}
      </template> -->
      <template #right>
        <button
          class="btn btn-sm"
          @click="router.push({ name: 'collectionEdit' })"
        >
          {{ $t(`collection.create`) }}
        </button>
        <button class="btn btn-primary btn-sm" @click="clickConfirm">
          {{ $t(`Buttons.confirm`) }}
        </button>
      </template>
    </ThreadsNav>
    <VanCheckboxGroup v-model="checked" class="overflow-y-auto">
      <VanCellGroup>
        <VanCell
          v-for="(item, index) in store.myCollection"
          :key="item"
          class="last:mb-10"
          clickable
          @click="toggle(index)"
        >
          <template #title>
            <div class="flex items-center gap-2.5">
              <div class="w-[45px]">
                <BaseImg :media="item.coverMedia" :width="90" ratio="1/1" />
              </div>
              {{ item.title }}
            </div>
          </template>
          <template #right-icon>
            <VanCheckbox
              :ref="(el:HTMLElement) => (checkboxRefs[index] = el)"
              :name="item.id"
              @click.stop
            />
          </template>
        </VanCell>
      </VanCellGroup>
    </VanCheckboxGroup>
  </VanPopup>
</template>

<script lang="ts" setup>
import { watch } from "vue";
import { onMounted } from "vue";
import { ref } from "vue";
import { PropType } from "vue";
import { useCollection } from "@/stores/collection";
import { useRouter } from "vue-router";
import { useI18n } from "vue-i18n";

const show = ref(false);
const store = useCollection();

const props = defineProps({
  selected: {
    type: Array as PropType<number[]>,
    required: true,
  },
});
const emit = defineEmits(["confirm"]);

const { locale } = useI18n();
const checked = ref<number[]>([]);
const checkboxRefs = ref<any[]>([]);
const toggle = (index: number) => {
  checkboxRefs.value[index].toggle();
};
const router = useRouter();

const clickConfirm = () => {
  emit("confirm", checked.value);
  show.value = false;
};

watch(
  () => props.selected,
  (val) => {
    checked.value = val;
  }
);

watch(
  () => show.value,
  (val) => {
    if (val) {
      checked.value = props.selected;
    }
  }
);

onMounted(async () => {
  store.getMyCollection();
});
</script>
